module.exports = __webpack_public_path__ + "static/img/xyqp-barnner.c0705ace.jpg";